export const canAcceptCreditCard = (customers) => {
    const providers = customers.flatMap((c) => c.providers).filter((p) => p.active === true);
    return providers.length > 0 && providers.every((p) => p.acceptCreditCard);
}